export const UI_DATE_FORMAT = 'dd.MM.yyyy';
export const UI_DATE_FORMAT_PLACEHOLDER = 'ДД.ММ.ГГГГ';
export const UI_DATE_FORMAT_NO_DAY = 'LLLL yyyy';
